import { useChainId } from 'wagmi'

import { ClaimableReward } from '../types'
import { SimplifiedQueryResult, transformSimplifiedQueryResult } from '@/domain/common/query'
import { useOpenDialog } from '@/domain/state/dialogs/hooks'
import { useNetworkChange } from '@/features/dialogs/select-network/logic/useNetworkChange'
import { useClaimableRewardsQuery } from '@/features/spark-rewards/data/useClaimableRewardsQuery'
import { claimSparkRewardsDialogConfig } from '@/features/spark-rewards/dialogs/claim-spark-rewards/ClaimSparkRewardsDialog'

export type UseClaimableRewardsResult = SimplifiedQueryResult<ClaimableRewardWithAction[]>
export interface ClaimableRewardWithAction extends ClaimableReward {
  actionName: string
  action: () => void
  isActionEnabled: boolean
  isGeoBlocked: boolean
}

export function useClaimableRewards(): UseClaimableRewardsResult {
  const openDialog = useOpenDialog()
  const { changeNetwork } = useNetworkChange()
  const connectedChainId = useChainId()
  const claimableRewardsResult = useClaimableRewardsQuery()

  return transformSimplifiedQueryResult(claimableRewardsResult, (data) =>
    data.map(({ rewardToken, cumulativeAmount, pendingAmount, preClaimed, chainId, isGeoBlocked }) => {
      const isConnectedChainReward = chainId === connectedChainId
      const amountToClaim = cumulativeAmount.minus(preClaimed)
      return {
        token: rewardToken,
        amountPending: pendingAmount,
        amountToClaim,
        chainId,
        actionName: isConnectedChainReward ? 'Claim' : 'Switch',
        isActionEnabled: (isConnectedChainReward && amountToClaim.gt(0)) || !isConnectedChainReward,
        isGeoBlocked,
        action: isConnectedChainReward
          ? () =>
              openDialog(claimSparkRewardsDialogConfig, {
                tokensToClaim: [rewardToken],
              })
          : () => changeNetwork(chainId),
      }
    }),
  )
}
